<template>
  <div>
    <Layout/>
    <h4>Médico</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idMedico" class="form-label">IdMedico</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMedico" name="idMedico" v-model="datoMedico.idMedico" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idPersona" name="idPersona" v-model="datoMedico.idPersona"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="persona" name="persona" v-model="datoMedico.persona" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalPersonaLOV"
                      title="Buscar Personas">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idEspecialidad" name="idEspecialidad" v-model="datoMedico.idEspecialidad"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idEspecialidad" class="form-label"> Especialidad</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="especialidad" name="especialidad" v-model="datoMedico.especialidad" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalEspecialidadLOV"
                      title="Buscar Especialidad">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="documento" class="form-label">Documento</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="documento" name="documento" v-model="datoMedico.documento" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarMedico" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarMedico" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditMedico" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdEspeMedi</th>
          <th scope="col">IdEspecialidad</th>
          <th scope="col">IdMedico</th>
          <th scope="col">Estado</th>
          <th scope="col">EspecialidadNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="espemedi in datosPaginados" :key="espemedi.idEspeMedi">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(espemedi.idEspeMedi)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(espemedi.idEspeMedi)" title="Editar">edit_square</i></td>
          <td>{{espemedi.idEspeMedi}}</td>
          <td>{{espemedi.idEspecialidad}}</td>
          <td>{{espemedi.idMedico}}</td>
          <td>{{espemedi.estado}}</td>
          <td>{{espemedi.especialidadNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteMedico(espemedi.idEspeMedi)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idEspeMedi" class="form-label">IdEspeMedi</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idEspeMedi" name="idEspeMedi" v-model="datoEspeMedi.idEspeMedi" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idEspecialidad" name="idEspecialidad" v-model="datoEspeMedi.idEspecialidad"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idEspecialidad" class="form-label"> Especialidad</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="especialidad" name="especialidad" v-model="datoEspeMedi.especialidad" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalEspecialidadLOV"
                      title="Buscar Especialidad">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idMedico" class="form-label">IdMedico</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMedico" name="idMedico" v-model="datoEspeMedi.idMedico" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarEspeMedi" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditEspeMedi" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!-- Lista de Valores: Persona -->
    <PersonaLOV @DatosPersona="GetDataPersonaLOV($event)"/>
<!-- Lista de Valores: Especialidad -->
    <EspecialidadLOV @DatosEspecialidad="GetDataEspecialidadLOV($event)"/>
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: EspeMedi -->
    <EspeMediLOVdet @DatosEspeMedi="GetDataEspeMediLOVdet($event)"/>
<!-- Lista de Valores: Especialidad -->
    <EspecialidadLOVdet @DatosEspecialidad="GetDataEspecialidadLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js';
// Listas de valores master
import PersonaLOV from '../../components/lovs/PersonaLOV.vue'
import EspecialidadLOV from '../../components/lovs/EspecialidadLOV.vue'
// Listas de valores master
// Listas de valores details
import EspeMediLOVdet from '../../components/lovs/EspeMediLOV.vue'
import EspecialidadLOVdet from '../../components/lovs/EspecialidadLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
, PersonaLOV
, EspecialidadLOV
// Listas de valores master
// Listas de valores details
, EspeMediLOVdet
, EspecialidadLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      medicos : [],
      datoMedico : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idMedico: '',
// Variables master
// Variables details
      espemedis : [],
      datoEspeMedi : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idMedico = this.$route.params.p_idmedico
    this.abrirEditar(this.p_idMedico)
    this.getEspeMedis()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      if(this.datoMedico.idMedico === ''){
        swal("Error!", "El elemento idMedico no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.idPersona === ''){
        swal("Error!", "El elemento idPersona no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.idEspecialidad === ''){
        swal("Error!", "El elemento idEspecialidad no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.documento === ''){
        swal("Error!", "El elemento documento no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarMedico(){
      if(this.validarForm() === 1){
        try {
          await api.post('/medicos', this.datoMedico)
          swal("Correcto!", "Medico creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditMedico(){
      if(this.validarForm() === 1){
        try {
          await api.post('/medicos', this.datoMedico)
          swal("Correcto!", "Medico creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoMedico={}
      this.titulo   = 'Crear Médico'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idMedico){
      this.modalWindow = true
      if(idMedico != null){    
           api.get('/vwmedicos/'+idMedico).then(resp=>{
          this.datoMedico = resp.data;
           });
      }
      this.titulo   = 'Editar Médico'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarMedico(){
      this.$router.push('/Medico')
    },
// Procedimientos master
// Procedimientos detalle
    async getEspeMedis() {
      const resp = await api.get('/espemedis')
      this.espemedis = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.espemedis.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwespemedis/nombre/'+this.nombreBusqueda).then(response=>{
          this.espemedis=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.espemedis.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwespemedis').then(response=>{
      this.espemedis=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.espemedis.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoEspeMedi.idMedico === ''){
        swal("Error!", "El elemento idMedico no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEspeMedi.idPersona === ''){
        swal("Error!", "El elemento idPersona no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEspeMedi.idEspecialidad === ''){
        swal("Error!", "El elemento idEspecialidad no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEspeMedi.documento === ''){
        swal("Error!", "El elemento documento no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoEspeMedi.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarEspeMedi(){
      if(this.validarForm() === 1){
        try {
          this.datoEspeMedi.idMedico = this.datoMedico.idMedico;
          await api.post('/espemedis', this.datoEspeMedi)
          this.getEspeMedis();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "EspeMedi creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditEspeMedi(){
      if(this.validarForm() === 1){
        try {
          await api.post('/espemedis', this.datoEspeMedi)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "EspeMedi creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoEspeMedi={}
      this.titulo   = 'Crear Médico'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idEspeMedi){
      this.modalWindow = true
      if(idEspeMedi != null){    
           api.get('/vwespemedis/'+idEspeMedi).then(resp=>{
          this.datoEspeMedi = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Médico'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idEspeMedi){
      this.modalWindow = true
      if(idEspeMedi != null){
        this.$router.push('/espemedimd/'+idEspeMedi)
      }
    },
    async deleteEspeMedi (idEspeMedi) {
      try{
        await api.delete('/espemedis/'+idEspeMedi)
          this.getEspeMedis()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
//    Lista de Valores
    GetDataPersonaLOV(data) {
      this.datoMedico.idPersona = data.idPersona;
      this.datoMedico.persona = data.nombre;
    },
//    Lista de Valores
    GetDataEspecialidadLOV(data) {
      this.datoMedico.idEspecialidad = data.idEspecialidad;
      this.datoMedico.especialidad = data.nombre;
    },
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataEspeMediLOVdet(data) {
      this.datoEspeMedi.idEspeMedi = data.idEspeMedi;
      this.datoEspeMedi.espeMedi = data.nombre;
    },
//    Lista de Valores
    GetDataEspecialidadLOVdet(data) {
      this.datoEspeMedi.idEspecialidad = data.idEspecialidad;
      this.datoEspeMedi.especialidad = data.nombre;
    },
// Listas de valores details
  },
}
</script>
